import React from 'react';
import { ActionsFeature, TblCol } from './table.types';

type TblColGroupParams = {
    actions?: ActionsFeature[];
    cols: TblCol[];
};

export const TableColGroup = ({ actions, cols }: TblColGroupParams): JSX.Element => {
    return (
        <colgroup>
            {actions?.map(action => (
                <col
                    key={action.columnTitle}
                    width="1"
                />
            ))}
            {cols.map(col => (
                <col
                    key={col.key}
                    width={col.width}
                />
            ))}
        </colgroup>
    );
};
